module.exports = __webpack_public_path__ + "static/media/screen-sign-in.64815783.png";